export const IMAGE_BACKGROUND_OVERRIDES = {
  playbooks: 'fill-accent-orange-hover',
  videoHostingManagement: 'fill-positive-subtle',
  bulkDuplicateManagement: 'fill-positive-subtle'
};
export const ILLUSTRATIONS = {
  campaignManagement: 'qualify-leads',
  socialMedia: 'social',
  websiteTrafficAnalytics: 'traffic-analytics',
  seoAnalytics: 'content-strategy',
  omniChannelMarketingAutomation: 'workflows',
  sequences: 'sequences',
  forecasting: 'forecasting',
  prospectingWorkspace: 'sales-professional',
  salesAutomation: 'workflows',
  playbooks: 'playbooks',
  whatsAppIntegration: 'whatsapp',
  videoHostingManagement: 'successfully-submitted-question',
  knowledgeBase: 'knowledge-base',
  forms: 'forms',
  landingPages: 'call-to-action',
  customReports: 'add-on-reporting',
  dataQualityCommandCenter: 'operations-custom-mappings',
  programmableAutomation: 'workflows',
  bulkDuplicateManagement: 'contacts',
  dataQualityAutomation: 'bolt'
};